import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralCurrentRankMinDepositByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': '테마',
  'common.themeLight': '라이트',
  'common.themeDark': '다크',
  'common.themeActive': '현재 적용 중',
  'common.themeSwitchToDark': '다크로 전환',
  'common.themeSwitchToLight': '라이트로 전환',
  'common.settings': '설정',
  'common.loading': '로딩 중…',
  'settings.language': '언어',
  'settings.savePreferences': '환경설정 저장',
  'settings.savingPreferences': '저장 중…',
  'auth.gate.userTitle': '세션 확인 중',
  'auth.gate.userDescription': '로그인을 확인하고 있습니다.',
  'auth.gate.agentTitle': '세션 확인 중',
  'auth.gate.agentDescription': '에이전트 로그인을 확인하고 있습니다.',
  'user.layout.sidebarTitle': 'MineMe 사용자 패널',
  'user.layout.logout': '로그아웃',
  'user.layout.nav.dashboard': '대시보드',
  'user.layout.nav.deposit': '입금',
  'user.layout.nav.withdraw': '출금',
  'user.layout.nav.investments': '투자',
  'user.layout.nav.referral': '추천',
  'user.layout.nav.notifications': '알림',
  'user.layout.nav.stopLoss': '스탑로스',
  'user.layout.nav.transactions': '거래',
  'user.layout.nav.settings': '설정',
  'user.layout.balance.available': '사용 가능 잔액',
  'user.layout.balance.frozen': '동결 잔액',
  'user.layout.balance.interest': '이자 잔액',
  'user.layout.balance.bonus': '보너스 잔액',
  'user.dashboard.balance.available': '사용 가능 잔액',
  'user.dashboard.balance.frozen': '동결 잔액',
  'user.dashboard.balance.interest': '적립 이자',
  'user.dashboard.balance.bonus': '보너스 잔액',

  'common.time.days': '일',
  'common.time.hours': '시간',
  'common.time.minutes': '분',
  'common.time.seconds': '초',

  'user.dashboard.title': '대시보드',
  'user.dashboard.loadingInvestments': '투자 상태를 불러오는 중…',
  'user.dashboard.stats.totalInvested': '총 투자액',
  'user.dashboard.stats.netPnl': '순손익',
  'user.dashboard.stats.activePlans': '진행 중인 플랜',
  'user.dashboard.noInvestment.title': '진행 중인 투자 없음',
  'user.dashboard.noInvestment.subtitle': '지금 투자를 시작하고 매력적인 수익으로 자산을 늘리세요',
  'user.dashboard.noInvestment.cta': '투자 플랜 둘러보기',
  'user.dashboard.recentTx.title': '최근 거래',
  'user.dashboard.recentTx.viewAll': '전체 보기',
  'user.dashboard.recentTx.col.date': '날짜',
  'user.dashboard.recentTx.col.type': '유형',
  'user.dashboard.recentTx.col.description': '설명',
  'user.dashboard.recentTx.col.amount': '금액',
  'user.dashboard.recentTx.col.status': '상태',
  'user.dashboard.recentTx.loading': '최근 거래를 불러오는 중…',
  'user.dashboard.recentTx.empty': '최근 거래가 없습니다.',
  'user.dashboard.tx.Deposit': '입금',
  'user.dashboard.tx.Investment': '투자',
  'user.dashboard.tx.Referral': '추천',
  'user.dashboard.tx.Bonus': '보너스',
  'user.dashboard.tx.Withdrawal': '출금',
  'user.dashboard.tx.E-Voucher': '전자 바우처',
  'user.dashboard.tx.Stop-Loss': '스탑로스',
  'user.dashboard.st.Completed': '완료',
  'user.dashboard.st.Active': '진행 중',
  'user.dashboard.st.Pending': '대기 중',
  'user.dashboard.st.Failed': '실패',
  'user.dashboard.invest.planFallback': '플랜',
  'user.dashboard.invest.activeBadge': '진행 중',
  'user.dashboard.invest.detail.amountInvested': '투자 금액',
  'user.dashboard.invest.detail.currentValue': '현재 가치',
  'user.dashboard.invest.detail.pl': '손익',
  'user.dashboard.invest.detail.interestRate': '이자율',
  'user.dashboard.invest.detail.perMonth': '월 {{pct}}%',
  'user.dashboard.invest.detail.duration': '기간',
  'user.dashboard.invest.detail.months': '{{n}}개월',
  'user.dashboard.invest.detail.startDate': '시작일',
  'user.dashboard.invest.detail.nextWithdrawal': '다음 출금',
  'user.dashboard.invest.countdownTitle': '다음 출금까지',
  'user.dashboard.invest.progress': '진행률',
  'user.dashboard.invest.progressPct': '{{pct}}% 완료',
  'user.dashboard.invest.earlyWithdraw': '조기 출금',
  'user.dashboard.invest.planChip': '{{name}} #{{num}}',
  'user.dashboard.invest.modal.title': '조기 출금 안내',
  'user.dashboard.invest.modal.investmentAmount': '투자 금액:',
  'user.dashboard.invest.modal.platformFee': '플랫폼 수수료 ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': '포기 이자:',
  'user.dashboard.invest.modal.youWillReceive': '받게 될 금액:',
  'user.dashboard.invest.modal.confirmHint': '계속하려면 CONFIRM을 입력하세요',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': '출금 확인',
  'user.dashboard.invest.modal.cancelling': '취소 중…',
  'user.dashboard.invest.toast.cancelled': '투자가 취소되었습니다',
  'user.dashboard.invest.toast.cancelFailed': '취소할 수 없습니다',

  'notifications.bell.triggerAria': '알림',
  'notifications.bell.title': '알림',
  'notifications.bell.loading': '로딩 중…',
  'notifications.bell.loadErrorSubtitle': '알림을 불러올 수 없습니다',
  'notifications.bell.unreadOne': '읽지 않은 업데이트 1개',
  'notifications.bell.unreadMany': '읽지 않은 업데이트 {{count}}개',
  'notifications.bell.allCaughtUp': '모든 알림을 확인했습니다',
  'notifications.bell.markAllRead': '모두 읽음으로 표시',
  'notifications.bell.empty': '아직 알림이 없습니다',
  'notifications.bell.emptyError': '알림을 불러올 수 없습니다',
  'notifications.bell.viewAll': '전체 보기',
  'notifications.bell.markReadAria': '읽음으로 표시',
  'notifications.bell.time.justNow': '방금',
  'notifications.bell.time.secondsAgo': '{{n}}초 전',
  'notifications.bell.time.minutesAgo': '{{n}}분 전',
  'notifications.bell.time.hoursAgo': '{{n}}시간 전',
  'notifications.bell.time.daysAgo': '{{n}}일 전',

  'agent.layout.logout': '로그아웃',
  'agent.layout.nav.dashboard': '대시보드',
  'auth.user.login.title': '사용자 로그인',
  'auth.user.login.signIn': '로그인',
  'auth.agent.login.title': '에이전트 로그인',
  'auth.agent.login.signIn': '로그인',

  ...panelSettingsTransactionsByLang.ko,
  ...panelReferralCurrentRankMinDepositByLang.ko,
  ...panelUserExtraByLang.ko,
  ...panelDwiOverrides.ko,
  ...panelDepositBonusByLang.ko,
  ...panelVoucherStatusByLang.ko,
  ...panelWithdrawBep20ByLang.ko,
  ...panelDepositVoucherOverrides.ko,
  ...panelInvestmentsOverrides.ko,
  'user.investments.card.dailyProfit': '일일 수익',
  'user.investments.card.earningDays': '영업일',
  'user.investments.card.earningDaysValue': '영업일 {{count}}일',
  'user.investments.card.expectedProfit': '예상 수익',
  'user.investments.card.investLimit': '투자 한도',
  'user.investments.card.investLimitLine': '{{days}}일 동안 {{count}}회',
  'user.investments.card.investLimitReached':
    '현재 기간에 이 플랜의 투자 한도에 도달했습니다.',
  'user.investments.card.limitReached': '한도 도달',
  ...panelStopLossSlotsAssignOverrides.ko,
  ...panelStopLossFlowByLang.ko,
  ...panelUserSignupSocialForgotByLang.ko,
  ...panelAgentDashboardByLang.ko,
  ...panelAgentReferralsByLang.ko,
  ...panelAgentCommissionsByLang.ko,
  ...panelAgentWithdrawByLang.ko,
  ...panelAgentWithdrawUnlockStringsByLang.ko,
  'agent.withdraw.unlock.loadingTitle': '출금 상태 확인 중…',
  'agent.withdraw.unlock.loadingSubtitle': '추천 진행 상황 및 해제 요건을 불러오는 중입니다',
  'agent.withdraw.form.loadingTitle': '출금 정보 불러오는 중…',
  'agent.withdraw.form.loadingHint': '잔액 및 해제 상태를 불러올 때까지 잠시 기다려 주세요',
  'agent.withdraw.unlock.requirementMet': '요건 충족',
  'agent.withdraw.unlock.minDepositHint':
    '추천 사용자만 해당됩니다(하위 에이전트 제외). 각 사용자는 완료된 입금이 최소 ${{amount}} 이상이어야 합니다.',
  ...panelAgentTransactionsByLang.ko,
  ...panelAgentLogsByLang.ko,
  ...panelAgentSettingsByLang.ko,
  ...panelAgentNotificationsByLang.ko,
  ...panelAgentTeamByLang.ko,
  ...panelAgentSignupByLang.ko,
  ...panelAgentLayoutByLang.ko,
  ...panelAgentAuthByLang.ko,
  ...panelUserPlatformTodayByLang.ko,
  ...panelStopLossHowLayoutByLang.ko,
  ...panelSupportTicketsByLang.ko,
});
